import SystemFieldProto from '../../proto/system-field-proto';
import mapProject from "../../import/normalize/map-project";
import SystemFieldProjectViewInImport from "./components/view-in-import";

export default class ProjectField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROJECT;
    }

    get sortHintMessage() {
        return 'Sort by Project/Folder';
    }

    getCsvValue(item) {
        const project = gd.session.projects.get(item.projectId);
        return project ? project.name : '';
    }

    getValue(item) {
        // return item.estimate
        return "ERROR-99j-9385";
    }

    // getAggregateClass() {return false}
    // getAggregateOptions() {return [
    //     gd.const.aggregate.type.SUM,
    //     gd.const.aggregate.type.MIN,
    //     gd.const.aggregate.type.MAX,
    //     gd.const.aggregate.type.MEDIAN,
    //     gd.const.aggregate.type.AVERAGE
    // ]}
    // getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    // listItemSortFunctions(sort) {
    //     return {
    //         functions: [i => i.item.estimate || 0],
    //         directions: [sort]
    //     }
    // }
    //
    // get AggregateComponent() {return AggregateTimeComponent.bind(null, this.getAggregateOptions());}


    // IMPORT

    normalizeCSVValue(value) {
        return mapProject(gd.companyId, null, value);
    }

    getComponentViewInImport() {
        return SystemFieldProjectViewInImport;
    }



}